import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Auth from "../pages/Auth";
import NotFound from "../pages/NotFound";
import {getAuthToken, getSupportUserCode} from "../helpers/authHelper";
import {isNotEmpty} from "../helpers/functions";

const Routing:React.FC = () => {
    return(
        <Switch>
            <Route path="/" exact>
                <NotFound />
            </Route>
            <Route path="/dashboard/:slug">
                <Dashboard />
            </Route>
            {/*<PrivateRoute path="/dashboard/:slug">*/}
            {/*    <Dashboard />*/}
            {/*</PrivateRoute>*/}
            <Route path="/auth">
                {(getAuthToken() && isNotEmpty(getAuthToken())) && (getSupportUserCode() && isNotEmpty(getSupportUserCode())) ? <Redirect to={"/dashboard/users/list"} /> : <Auth />}
            </Route>
            <Route path='*'>
                <NotFound />
            </Route>
        </Switch>
    )
}

export default Routing

{/*<PrivateRoute path="/dashboard/:slug">*/}
{/*    <PanelComponent />*/}
{/*</PrivateRoute>*/}